var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 39,
    viewBox: "0 0 43 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.04155 21.0874C-0.680517 16.3777 -0.680515 8.74189 4.04155 4.03224C8.76361 -0.677413 16.4196 -0.677412 21.1417 4.03224L25.5959 8.47475C32.7779 15.6379 32.7779 27.2517 25.5959 34.4149L21.5 38.5L4.04155 21.0874Z",
    fill: "#3FD2D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8584 4.03224C26.5804 -0.677413 34.2364 -0.677411 38.9585 4.03224C43.6805 8.74189 43.6805 16.3777 38.9585 21.0874L21.5 38.5L17.4042 34.4149C10.2221 27.2517 10.2221 15.6379 17.4042 8.47474L21.8584 4.03224Z",
    fill: "#33BCBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/app-logo.7c758e8b88f5d34e8b3f4adcedf69dde.svg";
export { ForwardRef as ReactComponent };